import React from 'react'
import AuditDataListfromApi from '../../../GlobalComponents/AuditDataListfromApi'

export default function MPRDetails() {
  return (
    <div
        style={{
          borderRadius: '4px',
          background:'#42a1ad',
        }}
      >
       <AuditDataListfromApi
        endpoint="/mpr"
        headerText="Monthly Progressive Report"
      />
      </div>
  )
}

 